export default "__VITE_ASSET__CXb_cIKl__"